<template>
    <div class="">
        <input type="text" v-model="inputValue" ref="input" />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: "",
        },
        modelValue: {
            type: [String, Number],
            default: undefined,
        },
        disableBlur: {
            type: [String, Number, Boolean],
            default: false,
        },
    },
    data() {
        return {
            inputValue:
                (this.modelValue !== undefined ? this.modelValue : this.value) +
                "",
        };
    },
    watch: {
        value: {
            handler(value) {
                if (
                    this.modelValue === undefined &&
                    value + "" !== this.inputValue
                ) {
                    this.inputValue = value + "";
                }
            },
        },
        modelValue: {
            handler(value) {
                if (value !== undefined && value + "" !== this.inputValue) {
                    this.inputValue = value + "";
                }
            },
        },
        inputValue: {
            handler(inputValue) {
                this.$emit("input", inputValue);
                this.$emit("update:modelValue", inputValue);
            },
        },
    },
    computed: {
        inputValueNumber: {
            get() {
                return +this.inputValue;
            },
            set(value) {
                this.inputValue = value + "";
            },
        },
        selectionStart() {
            return this.$refs.input.selectionStart;
        },
        selectionEnd() {
            return this.$refs.input.selectionEnd;
        },
        length() {
            return (this.inputValue ? this.inputValue + "" : "").trim().length;
        },
    },
    mounted() {},
    methods: {
        select() {
            this.$refs.input.select();
        },
        setSelectionRange(charStart = 0, charEnd) {
            const input = this.$refs.input;

            charEnd = !isNaN(+charEnd) ? +charEnd : input.selectionEnd;

            input.setSelectionRange(charStart, charEnd);
        },
        focus() {
            this.$refs.input.focus();
        },
        blur() {
            if (!this.disableBlur) {
                this.$refs.input.blur();
            }
        },
        isFocus() {
            const input = this.$refs.input;
            if (typeof input.isFocus === "function") {
                return input.isFocus();
            }

            return window.document.activeElement === this.$refs.input;
        },
        isBlur() {
            const input = this.$refs.input;
            if (typeof input.isBlur === "function") {
                return input.isBlur();
            }

            return !this.isFocus();
        },
    },
};
</script>
